var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m256 43.156c-118.741 0-215 96.258-215 215s96.259 215 215 215 215-96.259 215-215-96.259-215-215-215zm62.172 215h-42.9v144.525h-57.812v-144.525h-28.9v-57.81h28.666v-26.13c0-23.645 11.263-60.586 60.833-60.586l44.654.18v49.529h-32.434c-5.272 0-12.775 2.626-12.775 13.888v23.119h45.941z"}));
}

Facebook.defaultProps = {"id":"Layer_1","height":"512","viewBox":"0 0 512 512","width":"512","data-name":"Layer 1"};

module.exports = Facebook;

Facebook.default = Facebook;
